module.exports = __webpack_public_path__ + "static/img/data_sync.390addb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data_sync.png
// module id = +ky+
// module chunks = 1